module.exports = __webpack_public_path__ + "static/media/trioBettingHistory.a02ca3d5.png";